// extracted by mini-css-extract-plugin
export default {"container":"_r-z","heading":"as-z","text":"bs-z","info":"cs-z","link":"ds-z","fullMaxWidth":"es-z"};